import styled from 'styled-components';

import { FormComponent } from '../../../form';

export const PaymentRequestStyledFormComponentContainer = styled(FormComponent)`
    .payment-request-form {
        display: flex;
        flex-direction: column;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestFormComponentStyle.js